import React, { useEffect, useState } from "react";
import { adminDashboard } from "../services/api";
import AdminLayout from "./AdminLayout";

export default function AdminDashboard() {
  const [stats, setStats] = useState({
    products: 0,
    orders: 0,
    sliders: 0,
  });

  useEffect(() => {
    (async () => {
      try {
        const data = await adminDashboard();
        setStats(data);
      } catch (err) {
        console.error("Failed to load dashboard stats", err);
      }
    })();
  }, []);

  return (
    <AdminLayout>
      <div className="section-header" style={{ textAlign: "left", margin: "0 0 40px" }}>
        <h2 className="section-title">Ringkasan Dashboard</h2>
      </div>

      <div className="dashboard-grid">
        <div className="widget-card">
          <h4>Total Produk</h4>
          <div className="widget-value">{stats.products}</div>
          <p style={{ color: "#888", fontSize: "0.85rem", marginTop: "10px" }}>Koleksi kerajinan tangan</p>
        </div>

        <div className="widget-card">
          <h4>Total Pesanan</h4>
          <div className="widget-value">{stats.orders}</div>
          <p style={{ color: "#888", fontSize: "0.85rem", marginTop: "10px" }}>Pesanan pelanggan</p>
        </div>

        <div className="widget-card">
          <h4>Slider Aktif</h4>
          <div className="widget-value">{stats.sliders || 0}</div>
          <p style={{ color: "#888", fontSize: "0.85rem", marginTop: "10px" }}>Promosi di beranda</p>
        </div>
      </div>

      <div className="widget-card" style={{ maxWidth: "600px" }}>
        <h4>Selamat Datang, Admin</h4>
        <p style={{ marginTop: "15px", lineHeight: "1.8", color: "var(--text-light)" }}>
          Gunakan menu di samping untuk mengelola inventaris produk, melihat pesanan masuk, 
          mengatur slider promosi, dan memperbarui konfigurasi website.
        </p>
      </div>
    </AdminLayout>
  );
}
